var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.2 9.00005c0 3.97645-3.2235 7.19995-7.19995 7.19995s-7.2-3.2235-7.2-7.19995 3.22355-7.2 7.2-7.2 7.19995 3.22355 7.19995 7.2zm-7.19994-2.7c-.33199 0-.62317.17929-.78015.45065-.24888.43026-.79944.57728-1.22969.32839-.43026-.24888-.57728-.79944-.3284-1.22969.46549-.80469 1.33773-1.34935 2.33824-1.34935 1.49114 0 2.70004 1.20883 2.70004 2.7 0 1.1756-.7514 2.17571-1.80004 2.54636v.15364c0 .49705-.40294.89995-.9.89995-.49705 0-.9-.4029-.9-.89995v-.9c0-.49706.40295-.9.9-.9.49706 0 .9-.40294.9-.9s-.40294-.9-.9-.9zm-.00001 7.19995c.49706 0 .9-.4029.9-.9 0-.497-.40294-.9-.9-.9s-.9.403-.9.9c0 .4971.40294.9.9.9z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.303a4204195039badeff5e90927d9889.svg";
export { ForwardRef as ReactComponent };